import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "social-pages__group-title"
}
const _hoisted_3 = { class: "social-pages__item-info" }
const _hoisted_4 = {
  key: 0,
  class: "synced-info"
}

import dayjs from 'dayjs';
import { computed } from 'vue';
import VAssetName from './VAssetName.vue';
import VButton from './VButton.vue';
import VCollapse from './VCollapse.vue';
import SyncIcon from './icons/actions/SyncIcon.vue';
import ArrowRightCollapseIcon from './icons/other/ArrowRightCollapseIcon.vue';
import DeleteIcon from './icons/other/DeleteIcon.vue';
import { useConfirmModal } from '@/stores/confirm-modal';
import { facebookApi } from '@/api/facebook';
import { tiktokApi } from '@/api/tiktok';
import VSwitch from './VSwitch.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectedSocialPagesItem',
  props: {
    item: null,
    type: null,
    index: null
  },
  setup(__props: any) {

const props = __props as { 
  item: { id: number, name: string, picture?: string, avatar?: string, active?: boolean, is_business_active?: boolean, type_id: number, last_synced?: string, syncing?: boolean },
  type: string,
  index?: number
}


  
const keys = [ "businesses", "pages", "ad_accounts", "instagrams", "campaigns" ]
const titles: Record<string, string> = {
  "pages": "Pages",
  "ad_accounts": props.item.type_id === 3? "Advertisers": "Ad Accounts" 
}

const children = computed(() => {
  const arr: [ string, any, number ][] = []
  for (let key of keys) {
    const children = (props.item as any)[key]
    if (!children) continue
    for (let index = 0; index < children.length; index++) {
      if (key === "pages" && children[index].type_id === 2) continue  // skip instagram pages
      arr.push([ key, children[index],  index])
    }
  }
  return arr
})

const linted = computed(() => {
  return props.index && props.index % 2 === 1
})

const sync = computed(() => {
  return props.type === 'accounts' && props.item.last_synced
})

const confirmModal = useConfirmModal()
const syncAccount = async () => {
  props.item.syncing = true
  try {
    const resp = await facebookApi.sync(props.item.id)
    props.item.last_synced = resp.last_synced
  } finally {
    props.item.syncing = false
  }
}

const deleteAccount = (e: MouseEvent) => {
  confirmModal.open(e, `Are you sure you would like to disconnect ${props.item.name}?`, async () => {
    if (props.item.type_id === 1 || props.item.type_id === 2) {
      await facebookApi.disconnect([{ id: props.item.id }])
      props.item.active = false
    }
    if (props.item.type_id === 3) {
      await tiktokApi.disconnect([{ id: props.item.id }])
      props.item.active = false
    }
  })
}

const showSwitch = computed(() => {
  return [ 'pages', 'ad_accounts', 'businesses' ].includes(props.type)
})

const updateActive = async (value: boolean, e: MouseEvent) => {
  if (value === false) {
    confirmModal.open(e, `Are you sure you would like to disconnect ${props.item.name}?`, async () => {
      if (props.type === 'businesses' && props.item.type_id === 1) {
        await facebookApi.bms_disable([{ id: props.item.id }])
      }
      if (props.type === 'pages') {
        await facebookApi.pages_disable([{ id: props.item.id }])
      } 
      if (props.type === 'ad_accounts' && props.item.type_id === 1) {
        await facebookApi.ad_accounts_disable([{ id: props.item.id }])
      }
      if (props.type === 'ad_accounts' && props.item.type_id === 3) {
        await tiktokApi.advertiser_disable([{ id: props.item.id }])
      }
      props.item.active = false
    })
  } else {
    props.item.active = true
    if (props.type === 'businesses' && props.item.type_id === 1) {
        await facebookApi.bms_enable([{ id: props.item.id }])
      }
    if (props.type === 'pages') {
      await facebookApi.pages_enable([{ id: props.item.id }])
    } 
    if (props.type === 'ad_accounts' && props.item.type_id === 1) {
      await facebookApi.ad_accounts_enable([{ id: props.item.id }])
    }
    if (props.type === 'ad_accounts' && props.item.type_id === 3) {
      await tiktokApi.advertiser_enable([{ id: props.item.id }])
    }
  }
}


return (_ctx: any,_cache: any) => {
  const _component_ConnectedSocialPagesItem = _resolveComponent("ConnectedSocialPagesItem", true)!

  return (_unref(children).length > 0)
    ? (_openBlock(), _createBlock(VCollapse, {
        key: 0,
        class: "social-pages__item-collapse",
        "lazy-animation": "",
        opened: ""
      }, {
        activator: _withCtx(({ opened, toggle }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["social-pages__item", { opened, linted: _unref(linted) }])
          }, [
            _createElementVNode("div", {
              class: "social-pages__item-info",
              onClick: toggle
            }, [
              _createVNode(ArrowRightCollapseIcon, { class: "expand-icon" }),
              _createVNode(VAssetName, {
                item: props.item,
                class: "business"
              }, null, 8, ["item"])
            ], 8, _hoisted_1),
            (props.type === 'accounts')
              ? (_openBlock(), _createBlock(VButton, {
                  key: 0,
                  class: "icon-button",
                  onClick: deleteAccount
                }, {
                  default: _withCtx(() => [
                    _createVNode(DeleteIcon)
                  ]),
                  _: 1
                }))
              : (_unref(showSwitch))
                ? (_openBlock(), _createBlock(VSwitch, {
                    key: 1,
                    "model-value": props.item.active,
                    "model-business-value": props.item.is_business_active,
                    "onUpdate:modelValue": updateActive
                  }, null, 8, ["model-value", "model-business-value"]))
                : _createCommentVNode("", true)
          ], 2)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(children), (entry, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (entry[0] in titles && (index === 0 || entry[0] !== _unref(children)[index-1][0]))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(titles[entry[0]]), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_ConnectedSocialPagesItem, {
                item: entry[1],
                type: entry[0],
                index: entry[2]
              }, null, 8, ["item", "type", "index"])
            ], 64))
          }), 256))
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["social-pages__item empty", { linted: _unref(linted) }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(VAssetName, {
            item: props.item,
            class: "business"
          }, null, 8, ["item"]),
          (_unref(sync))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(dayjs)(props.item.last_synced).format("MM/DD/YYYY")), 1))
            : _createCommentVNode("", true)
        ]),
        (_unref(sync))
          ? (_openBlock(), _createBlock(VButton, {
              key: 0,
              class: _normalizeClass(["mr-1 sync-button", { disabled: props.item.syncing }]),
              onClick: syncAccount
            }, {
              default: _withCtx(() => [
                _createVNode(SyncIcon),
                (props.item.syncing)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Loading...")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Sync")
                    ], 64))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (props.type === 'accounts')
          ? (_openBlock(), _createBlock(VButton, {
              key: 1,
              class: "icon-button",
              onClick: deleteAccount
            }, {
              default: _withCtx(() => [
                _createVNode(DeleteIcon)
              ]),
              _: 1
            }))
          : (_unref(showSwitch))
            ? (_openBlock(), _createBlock(VSwitch, {
                key: 2,
                "model-value": props.item.active,
                "model-business-value": props.item.is_business_active,
                "onUpdate:modelValue": updateActive
              }, null, 8, ["model-value", "model-business-value"]))
            : _createCommentVNode("", true)
      ], 2))
}
}

})